<template>
  <div class="league">
    <Headers></Headers>
    <div class="league-center">
      <!-- bg -->
      <div class="center-img">
        <!-- <img src="https://aliyunosszs.musicwow.com/APPimg/league/leagueBg.png"/> -->
        <img :src="bgUrl" />
      </div>

      <!-- 四大合作理由 -->
      <div class="reason">
        <h2>朝阳行业，早加入，早赚到</h2>
        <h4>四大合作理由</h4>
        <ul>
          <li>
            <div class="reasonList_left">
              <img
                src="https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(17).png"
              />
            </div>
            <div class="reasonList_right">
              <p class="right_title">社会趋势</p>
              <p>近2.78亿目标人群，3千亿蓝海市场，预计3年将迎来爆发式增长</p>
            </div>
          </li>
          <li>
            <div class="reasonItem_left">
              <p class="right_title">专业支撑</p>
              <p>
                业内知名音乐大师提供标准、专业、系统化流行音乐课程的培训及资质评定
              </p>
            </div>
            <div class="reasonItem_right">
              <img
                src="https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(18).png"
              />
            </div>
          </li>
          <li>
            <div class="reasonList_left">
              <img
                src="https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(5).png"
              />
            </div>
            <div class="reasonList_right">
              <p class="right_title">快速招生</p>
              <p>
                3—18岁，各个年龄段的孩子均有刚性的学习需求，生源足，续费率高，效果好
              </p>
            </div>
          </li>
          <li>
            <div class="reasonItem_left">
              <p class="right_title">快速盈利</p>
              <p>
                可复制化品牌授权经营管理模式，快速复制、店长孵化、拓展分店，收益高
              </p>
            </div>
            <div class="reasonItem_right">
              <img
                src="https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(6).png"
              />
            </div>
          </li>
        </ul>
      </div>
      <!-- 六大合作优势 -->
      <div class="advantage">
        <h2>体验品牌财富，成功一键复制</h2>
        <h4>六大合作优势</h4>
        <ul>
          <li v-for="(item, index) in advantageList" :key="index">
            <img :src="item.imgUrl" />
            <p class="advantage_head">{{ item.head }}</p>
            <p>{{ item.text }}</p>
          </li>
          <li>
            <img
              src="https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(12).png"
            />
            <p class="advantage_head">盈利模式</p>
            <p>
              校区招生、游学、赛事、巡演、乐器销售等多种盈利模式，年纯利润<span
                >突破百万</span
              >
            </p>
          </li>
        </ul>
      </div>
      <!-- 打破传统模式 -->
      <div class="first">
        <h2 class="firstH2">音乐启蒙 ∙ 选择音乐窝</h2>
        <h4 class="firstH4">打破传统模式，用实力赢得市场先机</h4>
        <ul>
          <li v-for="(item, index) in firstList" :key="index">
            <img :src="item.imgUrl" />
            <div class="first_footer">
              <h2>{{ item.h2Title }}</h2>
              <h4>{{ item.h4Title }}</h4>
              <div class="bgShow"></div>
              <p v-for="(items, idx) in item.itemData" :key="idx">
                {{ items }}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 案例展示 -->
      <div class="case">
        <div class="case_item">
          <h2 class="firstH2">实践证明 成功可以复制</h2>
          <h4 class="firstH4">
            多年积淀，多次的成功复制，目前已经为100余家音乐教育机构提供了服务！
          </h4>
        </div>
      </div>
      <!-- 合作流程 -->
      <div class="flow">
        <h2>合作流程</h2>
        <div class="flow_item">
          <div class="item_left">
            <img src="../assets/img/league/icon-shenqing.png" />
            <div class="left_title">
              <div class="title_num">1</div>
              <div class="titlt_text">申请阶段</div>
            </div>
            <p>确定合作意向</p>
            <p>↓</p>
            <p>提高资质审核</p>
          </div>
          <div class="item_boult">
            <img
              src="https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(19).png"
            />
          </div>
          <div class="item_right">
            <img src="../assets/img/league/icon-kaohe.png" />
            <div class="left_title">
              <div class="title_num">2</div>
              <div class="titlt_text">考核阶段</div>
            </div>
            <p>门店商圈评估</p>
            <p>↓</p>
            <p>经营能力审核</p>
          </div>
        </div>
        <div class="flow_item">
          <div class="item_left">
            <img src="../assets/img/league/icon-qianyue.png" />
            <div class="left_title">
              <div class="title_num">3</div>
              <div class="titlt_text">签约阶段</div>
            </div>
            <p>签署合同协议</p>
            <p>↓</p>
            <p>支付相关费用</p>
          </div>
          <div class="item_boult">
            <img
              src="https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(19).png"
            />
          </div>
          <div class="item_right">
            <img src="../assets/img/league/icon-choubei.png" />
            <div class="left_title">
              <div class="title_num">4</div>
              <div class="titlt_text">筹备阶段</div>
            </div>
            <p>选址</p>
            <p>↓</p>
            <p>装修</p>
            <p>↓</p>
            <p>采购</p>
            <p>↓</p>
            <p>招聘</p>
          </div>
        </div>
        <div class="flow_item">
          <div class="item_left">
            <img src="../assets/img/league/icon-peixun.png" />
            <div class="left_title">
              <div class="title_num">5</div>
              <div class="titlt_text">培训阶段</div>
            </div>
            <p>师资培训</p>
            <p>↓</p>
            <p>认证</p>
            <p>↓</p>
            <p>考核</p>
            <p>↓</p>
            <p>运营管理培训</p>
          </div>
          <div class="item_boult">
            <img
              src="https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(19).png"
            />
          </div>
          <div class="item_right">
            <img src="../assets/img/league/icon-kaiye.png" />
            <div class="left_title">
              <div class="title_num">6</div>
              <div class="titlt_text">开业阶段</div>
            </div>
            <p>开业活动指导</p>
            <p>↓</p>
            <p>品牌运营支持</p>
          </div>
        </div>
      </div>
      <!-- 提交 -->
      <div class="formData">
        <div class="formData_item">
          <h2>音乐窝与您共同成长</h2>
          <h4>我们竭诚欢迎行业精英共图伟业</h4>
          <!-- <div class="addres" @click="handMapAddBut">
            <div>地区</div>
            <div class="map-add">{{address}}</div>
          </div> -->
          <div class="name">
            <v-distpicker
              ref="distpicker"
              :placeholders="{
                province: '-- 省 --',
                city: '-- 市 --',
                area: '-- 区 --',
              }"
              wrapper="distpicker-wrap"
              :province="currentDist.province"
              :city="currentDist.city"
              :area="currentDist.area"
              @province="(v) => (currentDist.province = v.value)"
              @city="(v) => (currentDist.city = v.value)"
              @area="(v) => (currentDist.area = v.value)"
            ></v-distpicker>
          </div>
          <div class="name">
            <input v-model="address" placeholder="地址" />
          </div>
          <div class="name">
            <input v-model="name" placeholder="姓名" />
          </div>
          <div class="phone">
            <!-- <select id="areaNum" v-model="selectedCode">
              
              <option v-for="(option,idx) in options" v-bind:value="option.value" :key="idx">
                {{ option.value }}
              </option>
            </select> -->
            <input
              id="userPhone"
              maxlength="11"
              v-model="phone"
              type="number"
              placeholder="手机号码"
            />
          </div>
          <div class="text">
            <textarea placeholder="咨询内容" v-model="userText"> </textarea>
          </div>
          <div class="formAdd" @click="handFormBut">在线提交</div>
        </div>
      </div>

      <!-- <div class="map-hide" @click="bandMapHideBUt" v-show="mapHide"></div>
      <div class="map-show" v-show="mapShow">
        <p>{{address}}</p>
        <v-distpicker type="mobile" @selected="onSelected" :static-placeholder="static" ></v-distpicker>
      </div> -->
    </div>
    <div class="footerShow">
      <Footer></Footer>
    </div>
    <Fixed></Fixed>
  </div>
</template>
<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import Fixed from "@/components/leagueFixed.vue";
import VDistpicker from "v-distpicker";
export default {
  name: "league",
  components: {
    VDistpicker,
  },
  data() {
    return {
      projectList: [],
      advantageList: [
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(7).png",
          head: "教学师资",
          text: "专业教学团队保障一流教学品质，人才定向培养保障师资团队",
        },
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(8).png",
          head: "课程体系",
          text: "特色课程课程体系，互联网创新教学模式，让教学更系统更高效",
        },
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(25).png",
          head: "运营团队",
          text: "经验丰富的专业运营管理团队，为合作校区提供全程指导与联合管理",
        },
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(9).png",
          head: "管理模式",
          text: "采用整店输出+OSO智能运营管理体系+全方位运营模式，让合作校区经营管理无忧",
        },
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(11).png",
          head: "营销模式",
          text: "线上线下全方位营销招生体系，让合作校区月月招生爆满",
        },
      ],
      firstList: [
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(20).png",
          h2Title: "七大课程体系",
          h4Title: "提高核心竞争力",
          itemData: [
            "- 与传统单一型培训机构相比，音乐窝课程更丰富 ",
            "- 涵盖民谣吉他、电吉他、爵士鼓、VGM声乐、非洲鼓、尤克里里、少儿钢琴",
            "- 立体式循环课堂，标准化教学课件，帮助学员启发思维、培养创作力",
          ],
        },
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(21).png",
          h2Title: "招生不用愁",
          h4Title: "线上线下全方位招生扶持",
          itemData: [
            "- 音乐窝快速招生：现场招生、线上招生、课堂招生及活动招生等+总部资源支持 ",
            "- 学员涵盖幼儿园、小学、初中全年龄层次，招生群体大",
            "- 成熟的招生模式，让每一次的招生都呈现火爆井喷态势",
          ],
        },
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/7c5ea79bd6f9fa4c771fde950663e0cf.png",
          h2Title: "音乐窝OSO智能运营管理体系",
          h4Title: "全面有效的提升整体运营管理效率",
          itemData: [
            "- 自主研发教务管理、运营管理、财务管理、权限管理、人脸识别考勤等，提高运营管理效率+总部资源支持 ",
            "- 通过小程序，实现排课考勤、实时监管教学进度，高效管理教务",
            "- 提供人事管理、学员管理、销售管理、财务管理、员工手册、行政管理、市场营销7大运营管理体系",
          ],
        },
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(23).png",
          h2Title: "音乐窝智能授课",
          h4Title: "帮助学生轻松练、教师轻松教、机构收益高",
          itemData: [
            "- 视频课程，海量课程资源，多种授课方式，在线实时教学互动，极致学习体验+总部资源支持 ",
            "- 超级网络课程，提供音乐名师教学，专业精品课程",
            "- 教辅工具，结合教材及标准化课件随堂教学，提高课堂互动性，学员更能轻松课后练习",
            "- 在线直播开课，智能约课，教师托管、双重收入",
          ],
        },
      ],
      bgUrl: "", //背景图片
      currentDist: {
        province: "", //省
        city: "", //市
        area: "", //地区
      },
      address: "", //地址
      name: "", //姓名
      phone: "", //电话
      userText: "", //咨询内容
      mapShow: false,
      mapHide: false,
      static: true,
      // selectedCode: '+86', //区号
      // options: [
      //   {  value: '+86' },
      //   {  value: '+852' },
      //   {  value: '+853' },
      //   {  value: '+886' }
      // ]
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
    Fixed,
  },
  methods: {
    handMapAddBut() {
      // console.log(111);
      this.mapShow = true;
      this.mapHide = true;
    },
    onSelected(data) {
      // console.log(data);
      this.address =
        data.province.value + " | " + data.city.value + " | " + data.area.value;
      this.province = data.province.value;
      this.city = data.city.value;
      this.county = data.area.value;
      // console.log(this.province);
      // console.log(this.city);
      // console.log(this.county);
    },
    bandMapHideBUt() {
      this.mapShow = false;
      this.mapHide = false;
    },
    handReservationBut() {
      this.$router.push({ name: "Reservation" });
    },
    async onBulist() {
      let bgData = await this.$API.getBgListData({});
      let listData = bgData.data;
      listData.forEach((item, index) => {
        switch (item.type) {
          case "mobile_join":
            this.bgUrl = item.image;
            break;
        }
      });
    },
    // 提交表单
    async handFormBut() {
      let that = this;
      if (!that.currentDist.province) {
        that.$toast("请先选择省");
        return false;
      }
      if (!that.currentDist.city) {
        that.$toast("请先选择市");
        return false;
      }
      if (!that.currentDist.area) {
        that.$toast("请先选择区");
        return false;
      }
      if (!that.address) {
        that.$toast("请先填写地址");
        return false;
      }
      if (!that.name) {
        that.$toast("请先填写姓名");
        return false;
      }
      if (!that.phone) {
        that.$toast("请先填写手机号码");
        return false;
      }
      await that.$API
        .getNewSave2Data({
          username: that.name,
          phone: that.phone,
          city:
            that.currentDist.province +
            that.currentDist.city +
            that.currentDist.area +
            that.address,
          content: that.userText,
          type: 1,
        })
        .then(function (res) {
          // console.log(res);
          if (res.code == 200) {
            that.$toast("提交成功");
            that.name = "";
            that.phone = "";
            that.address = "";
            that.userText = "";
            that.currentDist = {
              province: "",
              city: "",
              area: "",
            };
          } else {
            that.$toast(res.msg);
          }
        });
    },
  },
  mounted() {},
  created() {
    this.onBulist();
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/css/comp.scss";
.league-center {
  padding-top: 60px;
}
.league {
  width: 100%;
  height: 100%;

  .center-img {
    img {
      width: 100%;
    }
  }
  .reason {
    @extend .HTitle;
    ul {
      margin: 20px;
      li {
        display: flex;
        align-items: center;
        line-height: 20px;
        .reasonList_left {
          flex: 5;
          text-align: left;
          margin: 20px;
          img {
            width: 128px;
            height: 138px;
          }
        }
        .reasonList_right {
          flex: 5;
          color: #999999;
          font-size: 12px;
          text-align: left;
          margin: 20px;
          letter-spacing: 1px;
          .right_title {
            color: $DColor;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 15px;
          }
        }
        .reasonItem_left {
          flex: 5;
          color: #999999;
          font-size: 12px;
          text-align: right;
          margin: 20px;
          letter-spacing: 2px;
          .right_title {
            color: $DColor;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 15px;
          }
        }
        .reasonItem_right {
          margin: 10px;
          flex: 5;
          text-align: right;
          img {
            width: 128px;
            height: 138px;
          }
        }
      }
    }
  }
  .advantage {
    @extend .HTitle;
    background: #fff7e1;
    h4 {
      color: #ff8e15 !important;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      margin: 0 30px;
      li {
        margin: 20px auto;

        img {
          width: 62px;
          height: 62px;
        }
        p {
          font-size: $fontSize;
          color: rgba(88, 91, 99, 0.8);
          max-width: 82px;
          text-align: left;
          line-height: 20px;
          span {
            font-weight: 600;
          }
        }
        .advantage_head {
          font-size: 14px;
          font-weight: 600;
          text-align: center;
          line-height: 25px;
        }
      }
    }
  }
  .first {
    background-color: $DColor;
    background-image: url("https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(3).png");
    background-size: 100% 100%;
    @extend .HTitle;
    .firstH2 {
      color: $wBg;
    }
    .firstH4 {
      color: rgba(255, 255, 255, 0.6);
    }
    ul {
      li {
        background: $wBg;
        @extend .HTitle;
        padding: 0 0 !important;
        margin: 30px;
        border-radius: 16px;
        text-align: left;
        .bgShow {
          margin: 15px 0;
        }
        .first_footer {
          padding: 24px;
          p {
            line-height: 28px;
          }
        }
      }
    }
  }
  .case {
    background-image: url("https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(2).png");
    background-size: 100% 100%;
    height: 350px;
    // @extend .HTitle;
    display: flex;
    align-items: center;
    justify-content: center;
    .case_item {
      .firstH2 {
        color: $wBg;
        font-size: 23px;
        line-height: 35px;
        font-size: 23px;
        line-height: 35px;
      }
      .firstH4 {
        color: rgba(255, 255, 255, 0.6);
        max-width: 206px;
        line-height: 25px;
        font-size: 15px;
        margin: 15px auto;
        line-height: 25px;
        color: $TColor;
        font-size: 15px;
      }
    }
  }
  .flow {
    background-image: url("https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(10).png");
    background-size: 100% 100%;
    @extend .HTitle;
    .flow_item {
      display: flex;
      margin: 0 62px;
      .item_left,
      .item_right {
        margin: 20px auto;
        text-align: center;
        img {
          width: 90px;
          height: 90px;
        }
        .left_title {
          display: flex;
          margin: 15px 0;
          .title_num {
            background: $DColor;
            color: #fff;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            line-height: 16px;
          }
          .titlt_text {
            font-size: 12px;
            margin-left: 5px;
          }
        }
        p {
          color: $TColor;
          font-size: $fontSize;
          line-height: 16px;
        }
      }
      .item_boult {
        margin: 20px auto;
        img {
          width: 26px;
          height: 17px;
          margin-top: 35px;
        }
      }
    }
  }
  .formData {
    background-image: url("https://aliyunosszs.musicwow.com/APPimg/newLeague/newLeague(24).png");
    background-size: 100% 100%;
    @extend .HTitle;
    .formData_item {
      margin: 30px;
      padding: 20px;
      background: #fff;
      border-radius: 8px;
      .addres {
        width: 90%;
        display: flex;
        padding: 0 10px;
        height: 44px;
        border: 1px solid #ebebeb;
        line-height: 44px;
        border-radius: 4px;
        margin-top: 15px;
        .map-add {
          margin-left: 10px;
        }
      }
      .name {
        width: 90%;
        margin-top: 15px;
        height: 44px;
        padding: 0 10px;
        border: 1px solid #ebebeb;
        line-height: 44px;
        border-radius: 4px;
        text-align: left;
        input {
          height: 100%;
          font-size: 12px;
          width: 90%;
          border: none;
          outline: none;
        }
      }
      .phone {
        width: 90%;
        margin-top: 15px;
        padding: 0 10px;
        display: flex;
        height: 44px;
        border: 1px solid #ebebeb;
        line-height: 44px;
        border-radius: 4px;
        select {
          font-size: 12px;
          border: none;
          outline: none;
          option {
            outline: none;
          }
        }
        input {
          font-size: 12px;
          border: none;
          height: 100%;
          outline: none;
        }
      }
      .text {
        width: 90%;
        margin-top: 15px;
        text-align: left;
        textarea {
          width: 100%;
          padding: 0 10px;
          border: 1px solid #ebebeb;
          height: 142px;
          font-size: 12px;
          outline: none;
        }
      }
      .formAdd {
        width: 98%;
        margin-top: 15px;
        height: 37px;
        background: rgba(7, 209, 170, 1);
        box-shadow: 0px 5px 6px 0px rgba(7, 209, 170, 0.5);
        border-radius: 4px;
        color: #fff;
        line-height: 37px;
        font-size: 13px;
      }
    }
  }
}
.footerShow {
  padding-bottom: 56px;
}
.map-hide {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 888;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.map-show {
  position: fixed;
  z-index: 999;
  bottom: 0;
  width: 100%;
  height: 300px;
  overflow-y: scroll;
  background: #fff;
  p {
    padding: 20px 0;
    color: #07d1aa;
  }
}
</style>

